import _ from 'underscore';

let i18n = null;

// The filter will be like this:
// $filter=contains(HeadlinesAssetId, '12345;true;Headline1;Best;assettext')
function getParameter(value) {
  const parameters = value.split(';');
  const isPinned = parameters[1];
  const pinnedPosition = parameters[2];
  const performanceRating = parameters[3];
  const assetText = parameters[4];

  return {
    isPinned,
    pinnedPosition,
    performanceRating,
    assetText,
  };
}

export function initialize(options) {
  i18n = options.passedInI18n;
}

export function updateEntitySchemaForHeadlinesAssetId(entitySchema) {
  _.extend(entitySchema.properties, {
    HeadlinesAssetId: {
      name: 'HeadlinesAssetId',
      localize: (value) => {
        const {
          isPinned,
          pinnedPosition,
          assetText,
        } = getParameter(value);

        if (isPinned || pinnedPosition !== '') {
          return i18n.getString('Asset_Filter_Headline_Pinned_Content_No_PerformanceRating', {
            assetText,
            pinnedPosition: isPinned ? i18n.getString('PinnedAnyPosition') : i18n.getString(pinnedPosition),
          });
        }
        return i18n.getString('Asset_Filter_Headline_Content_No_PerformanceRating', {
          assetText,
        });
      },
      operatorDisplayNameMap: {
        contains: ' ',
      },
      filterable: true,
      property: 'HeadlinesAssetId',
      type: 'string',
      title: i18n.getString('HeadlinesAssetId'),
    },
  });

  return entitySchema;
}

export function updateEntitySchemaForDescriptionsAssetId(entitySchema) {
  _.extend(entitySchema.properties, {
    DescriptionsAssetId: {
      name: 'DescriptionsAssetId',
      localize: (value) => {
        const {
          isPinned,
          pinnedPosition,
          assetText,
        } = getParameter(value);

        if (isPinned || pinnedPosition !== '') {
          return i18n.getString('Asset_Filter_Description_Pinned_Content_No_PerformanceRating', {
            assetText,
            pinnedPosition: isPinned ? i18n.getString('PinnedAnyPosition') : i18n.getString(pinnedPosition),
          });
        }

        return i18n.getString('Asset_Filter_Description_Content_No_PerformanceRating', {
          assetText,
        });
      },
      operatorDisplayNameMap: {
        contains: ' ',
      },
      filterable: true,
      property: 'DescriptionsAssetId',
      type: 'string',
      title: i18n.getString('DescriptionsAssetId'),
    },
  });

  return entitySchema;
}
